module.exports = __webpack_public_path__ + "img/uk.cfc18f0f.png";